import { render, staticRenderFns } from "./ToiletEditor.vue?vue&type=template&id=35111d28&scoped=true&lang=pug"
import script from "./ToiletEditor.vue?vue&type=script&lang=ts"
export * from "./ToiletEditor.vue?vue&type=script&lang=ts"
import style0 from "./ToiletEditor.vue?vue&type=style&index=0&id=35111d28&prod&lang=scss"
import style1 from "./ToiletEditor.vue?vue&type=style&index=1&id=35111d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35111d28",
  null
  
)

export default component.exports